import { Component, Input } from '@angular/core';

import { ProfileIntroEditDialogService } from '@main-client/src/app/profile/profile-intro-edit-dialog/profile-intro-edit-dialog.service';

import { Account } from '@libs/src/models/account.model';
import { Profile } from '@main-client/src/app/profile/profile';

@Component({
  selector: 'app-profile-about',
  templateUrl: './profile-about.component.html',
})
export class ProfileAboutComponent {
  @Input() isUser: boolean;
  @Input() profile: Profile;
  @Input() user: Account;

  constructor(private profileEditDialog: ProfileIntroEditDialogService) {}

  openEditDialog() {
    return this.profileEditDialog.openEditDialog(
      this.isUser,
      this.profile,
      this.user,
      'inputAbout',
    );
  }
}
